import React from 'react'
import { Form } from 'react-redux-form/immutable'
import Panel from 'react-bootstrap/lib/Panel'

import FormHeader from './form-header'
import ListSubjects from './list-subjects'

const Wrapper = ({ data }) => (
  <Panel header='Certificate of Registration'>
    <Form model='corState' className='grid-form'>
      <FormHeader data={data.get('header')} />
      <ListSubjects
        data={data.get('subjects')}
        is_registered={data.get('header').get('is_registered')}
      />
    </Form>
    <small className='text-muted'>
      <em>
        *** To change section, click on the {`<>`} icon, and select the section
        you want to transfer to.
      </em>
      <br />
      <em>
        *** You may request a printed copy of this COR at the Registrar's
        Office.
      </em>
    </small>
  </Panel>
)

export default Wrapper



// WEBPACK FOOTER //
// ./src/containers/COR/wrapper.js